import { z } from 'zod';

export const backgroundCheckTypes = {
    manual: {
        jasType: undefined,
    },
    criminalSuper: {
        jasType: 'LEGACY',
    },
    legacySexOffender: {
        jasType: 'LEGACY_SEXOFFENDER',
    },
    standard: {
        jasType: 'STANDARD',
    },
} as const;

export const backgroundCheckTypesSchema = z.enum(
    Object.keys(backgroundCheckTypes) as [keyof typeof backgroundCheckTypes, ...Array<keyof typeof backgroundCheckTypes>],
);
export type BackgroundCheckType = z.infer<typeof backgroundCheckTypesSchema>;

export const backgroundCheckStatuses = {
    completeClear: 'Complete: Clear - No Matches Found',
    completeDenied: 'Complete: Denied',
    didNotConsent: 'Did Not Consent',
    formIncomplete: 'Form Incomplete',
    invalidSsn: 'Review and Take Action: Invalid SSN',
    missingFields: 'Required Fields Are Missing or Invalid',
    processingError: 'Processing: Error',
    processingNeedsAttention: 'Processing: Needs Attention',
    processingPending: 'Processing: Submission Pending',
    processingResearching: 'Processing: Researching',
    processingSubmitted: 'Processing: Submitted',
    readyToSubmit: 'Ready to Submit',
    reviewAndTakeAction: 'Review and Take Action: Possible Matches Found',
    unknown: 'Unknown',
} as const;

export const backgroundCheckStatusesSchema = z.enum(
    Object.keys(backgroundCheckStatuses) as [keyof typeof backgroundCheckStatuses, ...Array<keyof typeof backgroundCheckStatuses>],
);
export type BackgroundCheckStatus = z.infer<typeof backgroundCheckStatusesSchema>;
